<template>
    <div class="loginWrap" :class="{'loginPage':isloginPage}">
        <div class="loginBox" v-if="loadType=='load'">
          <div class="accountBox">
            <div class="loginTitle">{{loginMode==3?'欢迎注册章鱼·领会平台':'欢迎登录章鱼·领会平台'}}</div>
            <div class="formBox" v-show="loginMode === 1">
              <el-form ref="accountFrom" :model="accountForm" :rules="rules" class="commonFroms" :inline-message="true">
                <el-form-item prop="account">
                    <div class="inputItem">
                        <i class="iconfont icon-zhanghao"></i>
                        <el-input type="text" v-model="accountForm.account"  maxlength="11" placeholder="请输入手机号/账号" autocomplete="off" />
                    </div>
                </el-form-item>
                <el-form-item  prop="password">
                    <div class="inputItem">
                        <i class="iconfont icon-mima"></i>
                        <el-input type="password" v-model="accountForm.password" placeholder="请输入登录密码" autocomplete="new-password" />
                    </div>
                </el-form-item>
                <div class="switchBox">
                    <div class="forgot-password" @click="forgotPassword()">忘记密码？</div>
                    <div class="switchBtn" @click="modeSwitch">短信登录</div>
                </div>

                <el-button class="mainBtn loginBtn" @click="load">登录</el-button>
              </el-form>
            </div>

            <div class="formBox" v-show="loginMode === 2 || loginMode === 3" >
              <el-form   ref="phoneForm" :model="phoneForm" :rules="rules" class="commonFroms" :inline-message="true">
                <el-form-item prop="phone">
                    <div class="inputItem">
                        <i class="iconfont icon-shoujihao"></i>
                        <el-input type="text" v-model="phoneForm.phone" maxlength="11" :placeholder="'请输入手机号'" @blur="phoneBlur"/>
                    </div>
                </el-form-item>
                <el-form-item class="codeBox" prop="code">
                  <div class="inputBox">
                    <div class="inputItem">
                        <i class="iconfont icon-yanzhengma"></i>
                        <el-input type="text" v-model="phoneForm.code"  :placeholder="'请输入验证码'"/>
                    </div>
                    <el-button class="orangeText" type="text" :disabled="isdisabled" @click="getGraphicVcode('load')">{{codeText}}</el-button>
                  </div>
                </el-form-item>
                <div class="switchBox">
                    <div class="forgot-password" @click="forgotPassword()">忘记密码？</div>
                    <div class="switchBtn"  @click="modeSwitch">账号登录</div>
                </div>
                <el-button class="mainBtn loginBtn"  @click="load">{{loginMode == 2 ?'登录': loginMode == 3 ? '注册' : ''}}</el-button>
              </el-form>
            </div>
          </div>
          <div class="bottomBox">
            <div class="bottomLeft">
                <!--非微信内的移动端不展示-->
              <img :src="require('../../../../static/img/loginWeChat.png')" v-if="isFoxtip || (!isFoxtip && is_weixin())"
                   alt="" @click="wapLoadUri()" >
            </div>
            <div class="bottomRight">
              <div class="register" @click="registerHandle">注册账号</div>
            </div>
          </div>
        </div>

        <div class="loginBox" v-if="loadType=='binding'">
          <div class="accountBox">
            <div class="loginTitle">绑定手机号</div>
            <div class="formBox">
              <el-form   ref="phoneForm" :model="phoneForm" :rules="rules" class="commonFroms" :inline-message="true">
                <el-form-item prop="phone">
                    <div class="inputItem">
                        <i class="iconfont icon-shoujihao"></i>
                        <el-input type="text" v-model="phoneForm.phone" maxlength="11" :placeholder="'请输入手机号'" @blur="phoneBlur"/>
                    </div>
                </el-form-item>
                <el-form-item class="codeBox" prop="code">
                  <div class="inputBox">
                    <div class="inputItem">
                        <i class="iconfont icon-yanzhengma"></i>
                        <el-input type="text" v-model="phoneForm.code"  :placeholder="'请输入短信验证码'"/>
                    </div>
                    <el-button class="orangeText" type="text" :disabled="isdisabled" @click="getGraphicVcode('binding')">{{codeText}}</el-button>
                  </div>
                </el-form-item>
                <el-button class="mainBtn loginBtn"  @click="bingdingCheck">登录</el-button>
              </el-form>
            </div>
          </div>
          <div class="bottomBox"></div>
        </div>
        <el-dialog title="" :visible.sync="dialogWeChatCode" width="350px"  custom-class="dialogBoxA" class="dialogcomPaddingtBox  noheaderPadding" append-to-body="" :close-on-click-modal="false">
            <div class="permissionWrap">
                <div class="permissionBox">
                    <wxlogin v-if="dialogWeChatCode"
                        ref="wxlogin"
                        :appid="weChatConfig.appid"
                        :scope="weChatConfig.scope"
                        :redirect_uri='weChatConfig.redirect_uri'
                        :state='weChatConfig.state'
                        :theme="weChatConfig.theme"
                        :self_redirect="weChatConfig.self_redirect"
                    >
                    </wxlogin>
                </div>
            </div>
        </el-dialog>

        <div class="graphic-code" v-if="graphicVcodeShow">
            <div class="graphic-code-form">
                <div class="header">
                    <p class="title">图形验证码</p>
                    <i class="el-icon-close" @click="graphicVcodeShow = false"></i>
                </div>
                <div class="form-content-form">
                    <div class="form-content-item box-flex">
                        <el-input placeholder="请输入图形验证码" v-model="identiCode"></el-input>
                        <img v-show="graphicVcodeImage" class="code-img" :src="graphicVcodeImage" alt="" @click="getGraphicVcode(code_type)">
                        <div class="code-img" v-show="!graphicVcodeImage"></div>
                    </div>
                    <div class="form-content-item">
                        <el-button class="mainBtn" size="small" @click="getPhoneCode()">确定</el-button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {getAjax, postAjax} from '@/api/index.js';
import localStorageUtil from "../../../../static/utils/localStorageUtil";
import wxlogin from 'vue-wxlogin';
export default {
    inject: ['reload'],
    props:{
        isloginPage:{
            type:[Boolean,Number],
            default:false
        }
    },
    data(){
        var phoneReg = /^(13[0-9]|14[0-9]|15[0-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        var codeReg = /^[0-9]*$/;
        var phoneValidate = (rule,value,callback)=>{
            if (!value){
            return callback(new Error('请输入手机号'));
            }else if(!phoneReg.test(value)){
            return callback(new Error('手机号格式错误'));
            }else{
            return callback();
            }
        };
        var accountValidate = (rule,value,callback)=>{
            if(!value){
            return callback(new Error('请输入账号'));
            }else{
            return callback();
            }
        };
        var codeValidate = (rule,value,callback)=>{
            if(!value){
            return callback(new Error('请输入短信验证码'));
            }else if(!codeReg.test(value)){
            return callback(new Error('验证码格式错误'));
            }else{
            return callback();
            }
        }
        var passValidate = (rule,value,callback)=>{
            if(!value){
            return callback(new Error('请输入密码'));
            }else if(value.trim().length<6){
            return callback(new Error('密码长度少于6位'));
            }else{
            return callback();
            }
        }
        return{
            loginMode:1, // 1密码登录 2短信登录 3注册
            isdisabled:true,
            // dialogLogin:false,
            dialogPermission:false,
            dialogWeChatCode:false,
            graphicVcodeShow:false, // 图形验证码弹窗
            identiCode:'',
            graphicVcodeImage:'',
            code_type:'',
            accountForm:{
                account:'',
                password:'',
            },
            phoneForm:{
                phone:'',
                code:''
            },
            permissionForm:{
                phone:'',
                code:''
            },
            rules:{
                account:[{validator:accountValidate,trigger:'blur'}],
                phone:[{validator:phoneValidate,trigger:'blur'}],
                code:[{validator:codeValidate,trigger:'change'}],
                password:[{validator:passValidate,trigger:'blur'}],
            },
            weChatConfig:{
                appid:"",
                scope:'snsapi_login',
                redirect_uri:'',
                theme:'black',
                state:'',
                self_redirect:"false"
            },
            countdown:60,//60秒倒计时
            codeText :'获取验证码',
            loadType : "load",
            registerStr: "",//预注册字符串
            isLoginPage:null,
            qq_show:0,
            wechat_show:0,
            sign:"",

            isFoxtip:true,
        }
    },
    created(){

        if(this.$route.query.sign) this.sign = this.$route.query.sign;

        // this.qq_wechat();
        //登录页面
        if(this.isloginPage){
            this.registerStr='';
            this.accountForm.account='';
            this.accountForm.password='';
            this.phoneForm.phone='';
            this.phoneForm.code='';
            this.$nextTick(() => {
                this.$refs.accountFrom ? this.$refs.accountFrom.clearValidate() : false;
                this.$refs.phoneForm.clearValidate();
            })
            let doGetMyInfo = true ;
            let query = this.$route.query;


            if (query){
                if (query.w_code || query.w_state){
                doGetMyInfo = false;
                    if(query.load_type == 'wx')this.wapLoad(query.w_code,query.w_state) //微信扫码登录  则调用微信接口
                    if(query.load_type == 'qq')this.wapLoadQQLoad(query.w_code,query.w_state) //QQ扫码登录
                }

            }
            if (doGetMyInfo){
                if(window.localStorage.getItem("utoken")){
                //  this.getMyInfo()
                }
            }
        }else{
            this.accountForm.account='';
            this.accountForm.password='';
            this.phoneForm.phone='';
            this.phoneForm.code='';
            this.$nextTick(() => {
            this.$refs.accountFrom ? this.$refs.accountFrom.clearValidate() : false;
            this.$refs.phoneForm.clearValidate();
            })
        }

    },
    mounted(){
		window.addEventListener('keydown',this.keyDown);
        if (new RegExp("/Mobi|Android|webOS|iPhone|iPod|BlackBerry/i").test(navigator.userAgent)) {
            this.isFoxtip = false
        } else {
            this.isFoxtip = true //pc
        }
	},
    components:{
        wxlogin
    },
    methods:{
        qq_wechat(){
            getAjax("/index/index/QQ_Wechat").then((res)=> {

                this.qq_show = res.qq_show;
                this.wechat_show = res.wechat_show;
            });
        },
        getMyInfo(){
            let user_name = this.$store.state.user_name;
            if (user_name == null ){
                getAjax("/index/member/getMemberInfo").then((res)=> {
                    if (res.code ==1 ){
                    //用户已登录
                    this.$store.commit('setUserName', res.data.uname);
                    this.$store.commit('setAdmin_url', res.data.automatic_logon_uri);
                    this.$store.commit('setHeadimgurl', res.data.headimgurl);
                    this.$store.commit('setBbs_status', res.data.bbs_status);
                    this.$store.commit('setReply_status', res.data.reply_status);
                    }else{
                    //用户未登录 清除用户登录信息
                    this.$store.commit('setUserName', null);
                    this.$store.commit('setAdmin_url', null);
                    this.$store.commit('setHeadimgurl', null);
                    localStorageUtil.clearLoginStore();
                    }
                });
            }
        },
        modeSwitch(ind){
            // this.loginMode = ind;
            this.loginMode = this.loginMode === 1 ? 2 :1;
            if ( this.loginMode == 2){
                if( this.accountForm.account && !this.phoneForm.phone){
                    this.phoneForm.phone = this.accountForm.account
                    this.isdisabled = false
                }
            }
        },
        registerHandle(){
            this.loginMode = 3;
        },
        phoneBlur(){
            this.$refs.phoneForm.validateField('phone',err=>{
                if(!err){
                    this.isdisabled = false;
                }else{
                    this.isdisabled = true;
                }
            })
        },
        doDountdown(state){
            if (state === "start"){
                this.countdown = 60;
                this.isdisabled = true;
            }
            this.codeText = `${this.countdown}S`;
            if (this.countdown <= 0) {
                this.codeText = '获取验证码';
                this.isdisabled = false;
                return;
            } else {
                this.countdown--;
            }
            setTimeout(()=>{
                this.doDountdown("")
            },1000)
        },
        async load(){
            let promise = null;
            if (this.loginMode == 1){
                //账号密码登录
                promise = await this.phoneAndPass();
            }else if (this.loginMode == 2 || this.loginMode == 3){
                //账号密码登录
                promise = await this.phoneAndCode();
            }
            this.optLoadPromise(promise)
        },
        optLoadPromise(promise){
            if (!promise || promise.code != 1){
                this.$message({type: 'error', message: promise&&promise.msg ? promise.msg :'登录失败，请稍后再试!',duration:2000});
            } else {
                localStorageUtil.setCache("utoken", promise.data.utoken); //记录用户token
                localStorageUtil.setCache("utype", promise.data.utype); //记录用户token
                this.$store.commit("setUtype", promise.data.utype);
                this.$store.commit('setUtoken', promise.data.utoken);
                this.getMyInfo();

                if (this.isloginPage) {
                    this.$message({type: 'success', message: promise.msg,duration:2000});

                    if(promise.data.spaceid){

                        this.$router.push({
                            path: `/index/classDetail/${promise.data.spaceid}`
                        })
                        return true;
                    }
                    let redirect = this.$route.query.redirect;
                    if (redirect) {
                        this.$router.replace({path: redirect});
                    } else {
                    if(promise.data.utype==1){
                        this.$router.replace({path: '/'})
                    }else if(promise.data.utype==2){
                        this.$router.replace({path: '/'})
                    }

                    }
                } else {

                    this.clearWXQuery();//清楚微信回调记录
                    this.$store.commit('setDialogLogin',false);
                    this.reload();

                }
            }
        },
        //手机号+密码登录
        async phoneAndPass(){
            return  await postAjax("/login/passLoad",{phone:this.accountForm.account, password:this.accountForm.password,sign:this.sign}).then((res)=> {
                return res ;
            });
        },
        //手机号+验证码

        // 获取图形验证码
        getGraphicVcode(code_type){
            if (this.isdisabled ) return;
            this.graphicVcodeShow = true;
            this.code_type = code_type;
            postAjax('/index/login/verify',{}).then((res)=>{
                this.graphicVcodeImage=res;
            });
        },
        // 验证图形码

        //获取验证码
        async getPhoneCode(){
            this.isdisabled = true;
            await postAjax("/login/sendPhoneCode",{phone:this.phoneForm.phone,code_type:this.code_type,
                identiCode:this.identiCode}).then((res)=>{
                this.isdisabled = false;
                if (res.code ==1){
                    this.graphicVcodeShow = false;
                    this.doDountdown("start")
                    this.identiCode='';
                    this.$message({type: 'success', message: "验证码发送成功",duration:2000});
                }else{
                    this.getGraphicVcode(this.code_type);
                    this.identiCode='';
                    this.$message({type: 'error', message: res.msg,duration:2000});
                }
            }).catch(()=>{
                this.isdisabled = false;
            })
        },
        async phoneAndCode(){
            return  await postAjax("/login/phoneLoad",{phone:this.phoneForm.phone, code:this.phoneForm.code}).then((res)=> {
                return res ;
            });
        },
        bingdingCheck(){
            //绑定手机号  先校验该手机号是否已绑定过微信
            if (!this.phoneForm.code) return ;

            let checkPhone =  postAjax("/login/checkPhone", {phone:this.phoneForm.phone}).then((res)=>{
                if (res.code ==1){
                    //继续
                    this.bingding()

                }else if(res.code == 2){
                    this.$confirm("手机号已存在，点击继续绑定微信登录至此账号？", this.$t('Prompt'), {confirmButtonText: '继续', cancelButtonText: this.$t('Cancel'),
                    type: 'warning'
                    }).then(() => {
                        this.bingding()
                    })
                } else{
                    this.$message({type: 'error', message: res.msg,duration:2000});
                    return ;
                }
            })

        },
              //微信登录
        wapLoadUri(){

            let web_redirect_uri = '';
            /*if(this.isLoginPage){
            let href='';
            let redirect = this.$route.query.redirect;
            if(redirect){
                href = this.$router.resolve({path:redirect });
            }else{
                href = this.$router.resolve({path:'/user/home' });
            }
            web_redirect_uri = `${window.location.origin}/${href.href}`
            }else{
            web_redirect_uri = window.location.href;
            }*/
            let browser = !this.isFoxtip && this.is_weixin() ?  "weixin" : "";
            web_redirect_uri = window.location.href;
            postAjax("/weChat/wapLoadUri",{web_redirect_uri:web_redirect_uri, type:'load',browser:browser}).then((res)=> {
                this.weChatConfig.appid = res.data.appid;
                this.weChatConfig.redirect_uri = res.data.redirect_uri;
                this.weChatConfig.state = res.data.state;
                if(!this.isFoxtip && this.is_weixin()){

                    window.location.href= res.data.uri
                    return false ;
                }else{
                    this.dialogWeChatCode = true;
                }

            });

        },

        is_weixin(){
            var ua = navigator.userAgent.toLowerCase();
            if(ua.match(/MicroMessenger/i)=="micromessenger") {return true;} else {return false;}
        },

        //qq登录
        wapLoadQQUri(){
            let web_redirect_uri = '';

            web_redirect_uri = window.location.href;

            postAjax("/index/QQ/open",{web_redirect_uri:web_redirect_uri, type:'load'}).then((res)=> {

                if(res.code!=1)return false ;
                window.location.href = res.data;

            });

        },

        wapLoadQQLoad(code,state){
            let web_redirect_uri = '';

            web_redirect_uri = window.location.href;
            postAjax("/index/QQ/wapLoad?code="+code+'&state='+state).then((res)=> {
                if (res.code==1){
                    this.optLoadPromise(res)
                }else if(res.code==200){
                    this.openDialogLogin("binding");
                    this.registerStr = res.data.registerStr;

                }else{
                    this.$message({type: 'error', message: res.msg ,duration:2000});
                    this.clearWXQuery();//清除微信回调记录
                }


            });

        },

        wapLoad(code,state){
            postAjax("/weChat/wapLoad",{code:code, state:state}).then((res)=> {
            if (res.code==1){
                this.optLoadPromise(res)
            }else if(res.code==200){
                this.openDialogLogin("binding");
                this.registerStr = res.data.registerStr;
            }else{
                this.$message({type: 'error', message: res.msg ,duration:2000});
                this.clearWXQuery();//清除微信回调记录
            }
            });
        },

        bingding(){
            postAjax("/login/bindingPhone",{registerStr:this.registerStr,phone:this.phoneForm.phone, code:this.phoneForm.code}).then((res)=> {
            if (res.code==1){
                this.optLoadPromise(res)
            }else if(res.code==2){
                this.$message({type: 'error', message: res.msg,duration:3000});
            }else{
                this.$message({type: 'error', message: res.msg,duration:3000});
                this.reload()
            }
            });
        },
        openDialogLogin(loadType){
            this.loadType = loadType ? loadType : 'load';
            this.registerStr = ''
            this.accountForm.account='';
            this.accountForm.password='';
            this.phoneForm.phone='';
            this.phoneForm.code='';
            this.$nextTick(() => {
                this.$refs.accountFrom ? this.$refs.accountFrom.clearValidate() : false;
                this.$refs.phoneForm.clearValidate();
            })
        },
        keyDown(e){
            if(e.keyCode == 13){
                // 如果是图形验证码
                if(this.graphicVcodeShow){
                    return this.getPhoneCode();
                }
                if(this.loadType == 'load'){
                    this.load();
                }else if(this.loadType = 'binding'){
                    this.bingdingCheck();
                }
            }
        },
        dialogClosed(){
            window.removeEventListener('keydown',this.keyDown,false);
        },
        dialogOpen(){
            //   window.addEventListener('keydown',this.keyDown);
        },
        clearWXQuery(){
            let newQuery = JSON.parse(JSON.stringify(this.$route.query))
            if (newQuery.w_code || newQuery.w_state){
                //如果是微信扫码登录
                delete newQuery.w_code;
                delete newQuery.w_state;
                delete newQuery.load_type;
                this.$router.replace({query:newQuery});
            }
        },
        forgotPassword(){
            // 判断是开发环境还是生产环境
            if(process.env.NODE_ENV === 'development'){
                // 开发环境
                window.location.href = 'http://localhost:5173/#/resetPassword';
            }else{
                // 生产环境
                window.location.href = '/v3/#/resetPassword';
            }
        }
    },
    destroyed(){
      window.removeEventListener('keydown',this.keyDown,false);
    },
}
</script>
<style scoped lang="scss">
  @import '~@/assets/css/login/loginbox.scss'
</style>



// WEBPACK FOOTER //
// src/page/login/components/loginBox.vue